import { request } from "@/interface/helper";

const str = "communityTag";

export const communityTag = {
  [`${str}`]: {
    getList: data => request({ data, method: "get", url: "/community/tag/list" }),
    add: data => request({ data, method: "post", url: "/community/tag/add" }),
    detail: data => request({ data, method: "post", url: "/community/tag/detail" }),
    edit: data => request({ data, method: "post", url: "/community/tag/modify" })
  }
};
